import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
} from "mdbreact";
import { Authcontext } from "../context/Authcontext";
import { BookContext } from "../context/BookContext";
import { useState, useContext } from "react";
const CreateBooksList = ({ modal, toggle }) => {
  const { User } = useContext(Authcontext);
  const { addBook } = useContext(BookContext);

  const [Name, setName] = useState("");
  const [Author, setAuthor] = useState("");
  const [Date, setDate] = useState("");
  const [Price, setPrice] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleAuthorChange = (e) => {
    setAuthor(e.target.value);
  };
  const handleDateChange = (e) => {
    setDate(e.target.value);
  };
  const handlePriceChange = (e) => {
    setPrice(e.target.value);
  };

  const handleOnSubmit = (e) => {
    console.log("inside submit");
    e.preventDefault();
    console.log(User);
    const bookDetails = {
      name: Name,
      author: Author,
      price: Price,
      date: Date,
      user: User,
      read: false,
    };
    addBook(bookDetails);
    setName("");
    setPrice("");

    setAuthor("");
    toggle();
  };

  return (
    <MDBContainer>
      <MDBModal isOpen={modal} toggle={toggle}>
        <MDBModalHeader toggle={toggle}>Add Book Details</MDBModalHeader>

        <MDBModalBody>
          <form
            onSubmit={handleOnSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <MDBInput
              label="Book name"
             
              type="text"
              onChange={handleNameChange}
              value={Name}
            />
            <MDBInput
              label="Author"
           
              type="text"
              onChange={handleAuthorChange}
              value={Author}
              success="right"
            />
            <MDBInput
              label="Price"
            
              type="number"
              onChange={handlePriceChange}
              value={Price}
            />
            <div style={{
              display:"flex",
              flexDirection : "row",
              justifyContent : "space-between",
              marginBottom: "20px"
            }}>
            <h6>
              {" "}
              <MDBIcon icon="dot-circle" /> Date of Purchase:{" "}
            </h6>
            <input
              icon="calendar-alt"
              type="date"
              onChange={handleDateChange}
              value={Date}
            />

            </div>
            <input
              type="submit"
              value="submit"
              style={{
                backgroundColor: "#c51162",
                color: "white",
                padding: "10px 20px",
                borderRadius: "20px",
              }}
            />{" "}
          </form>
        </MDBModalBody>
      </MDBModal>
    </MDBContainer>
  );
};

export default CreateBooksList;
